export const Type = {
  System: {
    code: "system",
    name: "system",
    label: "system",
  },
  Public: {
    code: "public",
    name: "public",
    label: "Public",
  },
  Authenticated: {
    code: "authenticated",
    name: "authenticated",
    label: "Authenticated",
  },
  ToAuthenticate: {
    code: "to_authenticate",
    name: "to_authenticat",
    label: "ToAuthenticate",
  },
};

export const Page = {
  HomePage: {
    code: "HomePage",
    name: "HomePage",
    label: "HomePage",
    typeCode: Type.Public.code,
    locationPath: "/",
    componentPath: "pages/HomePage/HomePage",
    icon: "home",
    isMainMenu: true,
    exact: true,
    backPath: "",
    isRootRoute: true,
    roleCodes: ["root", "admin", "moderator", "staff", "user"],
  },
  SignInPage: {
    code: "SignInPage",
    name: "SignInPage",
    label: "SignInPage",
    typeCode: Type.ToAuthenticate.code,
    locationPath: "/sign-in",
    componentPath: "pages/SignInPage/SignInPage",
    icon: "login",
    isMainMenu: false,
    exact: true,
    backPath: "",
    isRootRoute: false,
    roleCodes: ["user", undefined],
  },
  SignUpPage: {
    code: "SignUpPage",
    name: "SignUpPage",
    label: "SignUpPage",
    typeCode: Type.ToAuthenticate.code,
    locationPath: "/sign-up",
    componentPath: "pages/SignUpPage/SignUpPage",
    icon: "account_circle",
    isMainMenu: true,
    exact: true,
    backPath: "",
    isRootRoute: true,
    roleCodes: ["user", undefined],
  },
  PasswordForgotPage: {
    code: "PasswordForgotPage",
    name: "PasswordForgotPage",
    label: "PasswordForgotPage",
    typeCode: Type.Public.code,
    locationPath: "/password-forgot",
    componentPath: "pages/PasswordForgotPage/PasswordForgotPage",
    icon: "none",
    isMainMenu: true,
    exact: true,
    backPath: "",
    isRootRoute: true,
    roleCodes: ["root", "admin", "moderator", "staff", "user"],
  },
  PasswordResetPage: {
    code: "PasswordResetPage",
    name: "PasswordResetPage",
    label: "PasswordResetPage",
    typeCode: Type.Public.code,
    locationPath: "/reset-password",
    componentPath: "pages/PasswordResetPage/PasswordResetPage",
    icon: "none",
    isMainMenu: true,
    exact: true,
    backPath: "",
    isRootRoute: true,
    roleCodes: ["root", "admin", "moderator", "staff", "user"],
  },
  ArticleListPage: {
    code: "ArticleListPage",
    name: "ArticleListPage",
    label: "ArticleListPage",
    typeCode: Type.Public.code,
    locationPath: "/articles/:parentName/:childName",
    componentPath: "pages/ArticleListPage/ArticleListPage",
    icon: "home",
    isMainMenu: true,
    exact: false,
    backPath: "",
    isRootRoute: true,
    roleCodes: ["root", "admin", "moderator", "staff", "user"],
  },
  ArticlePage: {
    code: "ArticlePage",
    name: "ArticlePage",
    label: "ArticlePage",
    typeCode: Type.Public.code,
    locationPath: "/articles/:parentName/:childName/:no",
    componentPath: "pages/ArticlePage/ArticlePage",
    icon: "home",
    isMainMenu: true,
    exact: false,
    backPath: "",
    isRootRoute: true,
    roleCodes: ["root", "admin", "moderator", "staff", "user"],
  },
  WeddingInvitationPage: {
    code: "WeddingInvitationPage",
    name: "WeddingInvitationPage",
    label: "WeddingInvitationPage",
    typeCode: Type.Public.code,
    locationPath: "/wedding-invitation/:name",
    componentPath: "pages/WeddingInvitationPage/WeddingInvitationPage",
    icon: "auto_awesome",
    isMainMenu: true,
    exact: false,
    backPath: "",
    isRootRoute: true,
    roleCodes: ["user", undefined],
  },

  // Admin Routes
  AdminDashboardPage: {
    code: "AdminDashboardPage",
    name: "AdminDashboardPage",
    label: "AdminDashboardPage",
    typeCode: Type.Authenticated.code,
    locationPath: "/management/dashboard",
    componentPath: "pagesAdmin/DashboardPage/DashboardPage",
    icon: "home",
    isMainMenu: true,
    exact: true,
    backPath: "",
    isRootRoute: true,
    roleCodes: ["root", "admin"],
  },
  AdminSystemSettingPage: {
    code: "AdminSystemSettingPage",
    name: "AdminSystemSettingPage",
    label: "AdminSystemSettingPage",
    typeCode: Type.Authenticated.code,
    locationPath: "/management/admin-system",
    componentPath: "pagesAdmin/SystemSettingPage/SystemSettingPage",
    icon: "settings",
    isMainMenu: true,
    exact: true,
    backPath: "",
    isRootRoute: true,
    roleCodes: ["root", "admin"],
  },
  AdminStatsPage: {
    code: "AdminStatsPage",
    name: "AdminStatsPage",
    label: "AdminStatsPage",
    typeCode: Type.Authenticated.code,
    locationPath: "/management/stats",
    componentPath: "pagesAdmin/StatsPage/StatsPage",
    icon: "leaderboard",
    isMainMenu: false,
    exact: true,
    backPath: "",
    isRootRoute: true,
    roleCodes: ["root", "admin", "moderator"],
  },
  AdminLibraryPage: {
    code: "AdminLibraryPage",
    name: "AdminLibraryPage",
    label: "AdminLibraryPage",
    typeCode: Type.Authenticated.code,
    locationPath: "/management/library",
    componentPath: "pagesAdmin/LibraryPage/LibraryPage",
    icon: "panorama",
    isMainMenu: true,
    exact: true,
    backPath: "",
    isRootRoute: true,
    roleCodes: ["root", "admin"],
  },
  AdminArticleCategoryListPage: {
    code: "AdminArticleCategoryListPage",
    name: "AdminArticleCategoryListPage",
    label: "AdminArticleCategoryListPage",
    typeCode: Type.Authenticated.code,
    locationPath: "/management/article-category-list",
    componentPath: "pagesAdmin/ArticleCategoryListPage/ArticleCategoryListPage",
    icon: "category",
    isMainMenu: true,
    exact: true,
    backPath: "",
    isRootRoute: true,
    roleCodes: ["root", "admin"],
  },
  AdminArticleListPage: {
    code: "AdminArticleListPage",
    name: "AdminArticleListPage",
    label: "AdminArticleListPage",
    typeCode: Type.Authenticated.code,
    locationPath: "/management/article-list",
    componentPath: "pagesAdmin/ArticleListPage/ArticleListPage",
    icon: "newspaper",
    isMainMenu: true,
    exact: true,
    backPath: "",
    isRootRoute: true,
    roleCodes: ["root", "admin"],
  },
  AdminAccessHistoryListPage: {
    code: "AdminAccessHistoryListPage",
    name: "AdminAccessHistoryListPage",
    label: "AdminAccessHistoryListPage",
    typeCode: Type.Authenticated.code,
    locationPath: "/management/access-history-list",
    componentPath: "pagesAdmin/AccessHistoryListPage/AccessHistoryListPage",
    icon: "lock_open",
    isMainMenu: true,
    exact: true,
    backPath: "",
    isRootRoute: true,
    roleCodes: ["root", "admin"],
  },
  AdminUserListPage: {
    code: "AdminUserListPage",
    name: "AdminUserListPage",
    label: "AdminUserListPage",
    typeCode: Type.Authenticated.code,
    locationPath: "/management/user-list",
    componentPath: "pagesAdmin/UserListPage/UserListPage",
    icon: "group",
    isMainMenu: true,
    exact: true,
    backPath: "",
    isRootRoute: true,
    roleCodes: ["root", "admin", "moderator"],
  },
  AdminWeddingInvitationListPage: {
    code: "AdminWeddingInvitationListPage",
    name: "AdminWeddingInvitationListPage",
    label: "AdminWeddingInvitationListPage",
    typeCode: Type.Authenticated.code,
    locationPath: "/management/wedding-invitation-list",
    componentPath: "pagesAdmin/WeddingInvitationListPage/WeddingInvitationListPage",
    icon: "auto_awesome",
    isMainMenu: true,
    exact: true,
    backPath: "",
    isRootRoute: true,
    roleCodes: ["root", "admin", "moderator"],
  },

  // System Routes
  MaintenancePage: {
    code: "MaintenancePage",
    name: "MaintenancePage",
    label: "MaintenancePage",
    typeCode: Type.System.code,
    locationPath: "/maintenance",
    componentPath: "pages/MaintenancePage/MaintenancePage",
    icon: "none",
    isMainMenu: false,
    exact: undefined,
    backPath: "",
    isRootRoute: true,
    roleCodes: ["root", "admin", "moderator", "staff", "user"],
  },
  AccessDeniedPage: {
    code: "AccessDeniedPage",
    name: "AccessDeniedPage",
    label: "AccessDeniedPage",
    typeCode: Type.System.code,
    locationPath: "/access-denied",
    componentPath: "pages/AccessDeniedPage/AccessDeniedPage",
    icon: "none",
    isMainMenu: false,
    exact: undefined,
    backPath: "",
    isRootRoute: true,
    roleCodes: ["root", "admin", "moderator", "staff", "user"],
  },
  NotFoundPage: {
    code: "NotFoundPage",
    name: "NotFoundPage",
    label: "NotFoundPage",
    typeCode: Type.System.code,
    locationPath: "*",
    componentPath: "pages/NotFoundPage/NotFoundPage",
    icon: "none",
    isMainMenu: false,
    exact: undefined,
    backPath: "",
    isRootRoute: true,
    roleCodes: ["root", "admin", "moderator", "staff", "user"],
  },
};